module.exports = __webpack_public_path__ + "img/0.7ac20d6d.png";